'use strict';

angular.module('substoreApp.services')
    .service('productDataCollector', [function () {
        /**
         * Collect some data from product description. The services delivering
         * product data do extensively use array for text and image properties.
         * Those properties hardly to display by NG expressions are collected
         * from the product description arrays and stored as regular properties
         * in the product.
         * This function is destructive as it modifies the given product
         * instance.
         */

        function reorderGalleryImages(images) {
            // because imageIds are ordinals not guaranteed to be dense as well as they
            // increment across all translation languages imageIds might have to be normalized
            var collections = {
                imageGallery: [],
                thumbnailGallery: []
            };
            // first: collect both relevant kinds of images
            angular.forEach(images, function(image) {
                if (collections[image.name] !== undefined)
                    collections[image.name][image.imageId] = image;
            });
            // second: reorder images of both collection
            angular.forEach(collections, function(collection) {
                for (var i = 0, j = 0; i < collection.length; i++)
                    if (collection[i])
                        collection[i].imageId = ++j;
            });
        }

        return {
            collect: function (product) {
                return this._collect(product, false);
            },
            collectWithGallery: function (product) {
                return this._collect(product, true);
            },
            _collect: function (product, withGallery) {

                product.texts = {};
                product.images = {};
                product.gallery = {};
                product.hyperlinks = {};

                var textsCount = product.productDescription.texts.length;
                if (textsCount > 0) {
                    var texts = {};
                    for (var i = 0; i < textsCount; i++) {
                        var tuple = product.productDescription.texts[i];
                        texts[tuple.name] = tuple.text;
                    }
                    product.texts = texts;
                }

                var textLists = {};
                angular.forEach(product.productDescription.textLists, function(value, key) {
                    textLists[key] =  [];
                    for (var i = 0; i < value.length; i++)
                        textLists[key].push(value[i].text);
                });
                product.textLists = textLists;

                var imagesCount = product.productDescription.images.length;
                if (imagesCount > 0) {
                    var images = {};
                    var gallery = [];
                    if (withGallery)
                        reorderGalleryImages(product.productDescription.images);

                    for (var i = 0; i < imagesCount; i++) {
                        var tuple = product.productDescription.images[i];
                        var isGallery = (tuple.name === 'imageGallery' || tuple.name === 'thumbnailGallery');
                        if (withGallery && isGallery) {
                            var imageId = tuple.imageId;
                            var galleryItem = gallery[imageId - 1];
                            if (!galleryItem)
                                galleryItem = gallery[imageId - 1] = {};

                            galleryItem[tuple.name] = {
                                alt: tuple.alt,
                                resourcePath: tuple.resourcePath
                            }
                        } else {
                            images[tuple.name + "Alt"] = tuple.alt;
                            images[tuple.name + "ResourcePath"] = tuple.resourcePath;
                        }
                    }
                    product.images = images;
                    if (withGallery)
                        product.gallery = gallery;
                }

                var hyperlinksCount = product.productDescription.hyperlinks.length;
                if (hyperlinksCount > 0) {
                    var hyperlinks = {};
                    for (var i = 0; i < hyperlinksCount; i++) {
                        var tuple = product.productDescription.hyperlinks[i];
                        hyperlinks[tuple.name + "DisplayName"] = tuple.displayName;
                        hyperlinks[tuple.name + "Url"] = tuple.url;
                    }
                    product.hyperlinks = hyperlinks;
                }

                return product;
            }
        }
    }]);